module.exports = __webpack_public_path__ + "img/museum.9a7e80f5.png";